import Person from '@shared/assets/icons/action/person.svg?react';
import { Avatar as AntDAvatar, AvatarProps } from 'antd';
import cn from 'classnames';
import './avatar.styles.scss';

interface Props extends AvatarProps {
    firstName?: string;
    lastName?: string;
}

export default function Avatar({ className, firstName, lastName, ...props }: Readonly<Props>) {
    if (firstName || lastName) {
        return (
            <AntDAvatar
                {...props}
                className={cn('avatar', className)}
            >
                {firstName?.[0]}
                {lastName?.[0]}
            </AntDAvatar>
        );
    }

    return (
        <AntDAvatar
            icon={<Person />}
            {...props}
            className={cn('avatar', className)}
        />
    );
}
